import { render, staticRenderFns } from "./updatepopup.vue?vue&type=template&id=5919955a&scoped=true&"
import script from "./updatepopup.vue?vue&type=script&lang=js&"
export * from "./updatepopup.vue?vue&type=script&lang=js&"
import style0 from "./updatepopup.vue?vue&type=style&index=0&id=5919955a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919955a",
  null
  
)

export default component.exports